export default __webpack_public_path__ + "static/media/HealthAssur.ac3c58c6.jpeg";